<script setup>
import HeroMobile from './hero/HeroMobile.vue'
import HeroTablet from './hero/HeroTablet.vue'
import HeroDesktop from './hero/HeroDesktop.vue'

const emit = defineEmits(['scroll-to-stats'])

const onScrollToStats = () => emit('scroll-to-stats')
</script>

<template>
  <section class="hero-section">
    <div class="hero-background">
      <div class="hero-gradient"></div>
      <div class="hero-pattern"></div>
    </div>
    <div class="container hero-container">
      <HeroMobile @scroll-to-stats="onScrollToStats" />
      <HeroTablet @scroll-to-stats="onScrollToStats" />
      <HeroDesktop @scroll-to-stats="onScrollToStats" />
    </div>
    <div class="hero-scroll-indicator">
      <svg
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M12 5v14M5 12l7 7 7-7" />
      </svg>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.hero-section {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  padding: 80px 0 var(--spacing-xl);
  overflow-x: hidden;
  overflow-y: visible;
}

@media (min-width: 768px) {
  .hero-section {
    padding-top: 100px;
  }
}

.hero-background {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.hero-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 50% -20%, rgba(30, 41, 59, 0.08) 0%, transparent 50%),
    radial-gradient(ellipse 60% 40% at 90% 80%, rgba(51, 65, 85, 0.06) 0%, transparent 50%);
}

.hero-pattern {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(30, 41, 59, 0.08) 1px, transparent 1px);
  background-size: 24px 24px;
  opacity: 0.5;
}

.hero-container {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-xl);
}

@media (min-width: 1024px) {
  .hero-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-3xl);
    align-items: center;
    text-align: right;
  }
}

.hero-scroll-indicator {
  display: none;
}

@media (min-width: 768px) {
  .hero-scroll-indicator {
    display: block;
    position: absolute;
    bottom: var(--spacing-xl);
    left: 50%;
    transform: translateX(-50%);
    color: var(--text-muted);
    animation: bounce 2s infinite;
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(8px);
  }
}
</style>
